import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/tradiglo.malaysia/page.tsx");
